import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    icon: '📖',
    num: 'Tomo 1',
    title: 'Origen de los Pueblos del Norte',
    desc: 'Conocé cómo surgieron los pueblos escandinavos, cómo vivían y cuáles fueron las condiciones que dieron origen a la cultura vikinga.'
  }, {
    icon: '📖',
    num: 'Tomo 2',
    title: 'La Era Vikinga',
    desc: 'Descubrí la expansión vikinga, sus expediciones, el comercio, los drakkars y las conquistas que transformaron Europa.'
  }, {
    icon: '📖',
    num: 'Tomo 3',
    title: 'Dioses, Mitos y Leyendas Nórdicas',
    desc: 'Adentrate en la cosmovisión nórdica, los Nueve Mundos y las historias de Odin, Thor, Loki y las principales deidades.'
  }, {
    icon: '📖',
    num: 'Tomo 4',
    title: 'Guerreros, Batallas y Exploradores',
    desc: 'Conocé las armas, estrategias, grandes batallas y las expediciones que llevaron a los vikingos hasta Islandia, Groenlandia y Vinland.'
  }, {
    icon: '📖',
    num: 'Tomo 5',
    title: 'Runas, Magia y Creencias del Norte',
    desc: 'Explorá el origen de las runas, las antiguas tradiciones, los rituales y la espiritualidad del mundo nórdico desde una perspectiva histórica.'
  }, {
    icon: '📖',
    num: 'Tomo 6',
    title: 'El Legado Vikingo en la Historia Moderna',
    desc: 'Descubrí cómo la cultura vikinga continúa presente en la historia, la arqueología, la literatura, el cine y los videojuegos.'
  }];
  return <section className="py-20 md:py-32 px-4 relative" data-id="element-275">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-276" />

      <div className="max-w-6xl mx-auto" data-id="element-277">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-278">
          <div className="inline-block mb-4" data-id="element-279">
            <span className="text-gold text-4xl" data-id="element-280">⚔️</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6 text-white" data-id="element-281">
            Una colección completa compuesta por 6 tomos exclusivos
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16" data-id="element-282">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card border border-dark-border p-8 rounded-xl hover:border-gold/40 transition-all group relative overflow-hidden" data-id="element-283">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110" data-id="element-284" />

              <div className="flex items-center gap-3 mb-4" data-id="element-285">
                <span className="text-3xl" data-id="element-286">{tomo.icon}</span>
                <div className="text-gold font-bold text-sm tracking-widest uppercase" data-id="element-287">
                  {tomo.num}
                </div>
              </div>
              <h4 className="text-2xl font-heading font-bold text-white mb-4" data-id="element-288">
                {tomo.title}
              </h4>
              <p className="text-gray-300 leading-relaxed relative z-10" data-id="element-289">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}